export const TRADE_BOARDCAST_RIGHT_BAR_ACTIONS = {
    TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_RESPONSE: 'TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_RESPONSE',
    TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_REQUEST: 'TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_REQUEST',
    TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_ERROR: 'TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_ERROR',
  };